<div class="wrapper">
  <div class="field">
    <ng-container #fieldComponent></ng-container>
  </div>

  <span class='hint-text'>{{ field.hintText }}</span>
</div>
